import {
  ChangeHCP,
  CloseAccount,
  ReopenAccount,
  InvitePatient,
  ResendInvitation,
  StartOutOfOffice,
  EndOutOfOffice,
} from "./";
import { Text, BoxButton } from "shared";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FormatListBulleted } from "@material-ui/icons";
import useTherapist from "../queries/useTherapist";
import useTimeOffPeriod from "../queries/useTimeOffPeriod";
import type { Country } from "utils/market";
import { Area } from "types";

const Actions = () => {
  const { t } = useTranslation();

  const { data: pt } = useTherapist();
  const { data } = useTimeOffPeriod(pt?.time_off_period?.id);

  const showStartOutOfOffice = () => {
    return (
      data?.status === undefined ||
      ["failed", "pending", "ended"].includes(data.status) ||
      pt?.time_off_period?.status === "ended"
    );
  };

  return (
    <div>
      <Text paragraph caption secondary>
        {t`patients.actions`}
      </Text>
      {pt?.deleted_at ? <ReopenAccount /> : <CloseAccount />}
      {pt && <InvitePatient therapistId={pt.id} country={pt?.country as Country} />}
      {pt && (
        <BoxButton
          component={Link}
          to={`${Area.Invitations}?therapist_id=${pt.id}`}
          startIcon={<FormatListBulleted />}
          style={{ textDecoration: "none" }}
        >
          {t("invitations.view_therapist_invitations")}
        </BoxButton>
      )}
      <ResendInvitation />
      <ChangeHCP />
      {showStartOutOfOffice() ? (
        <>
          <StartOutOfOffice />
          {data?.status === "failed" && data?.resulting_errors && <div>Error: {data?.resulting_errors[0]}</div>}
        </>
      ) : (
        <EndOutOfOffice />
      )}
    </div>
  );
};
export default Actions;
